import { Injectable, inject } from '@angular/core';
import { AB_TEST_CONFIG } from '../tokens/external.tokens';

/**
 * Debug logger utility for AB Test library
 * Respects the debugMode configuration setting from injected config
 */
@Injectable({
  providedIn: 'root',
})
export class DebugLogger {
  private config = inject(AB_TEST_CONFIG);

  /**
   * Get current debug mode from configuration
   */
  getDebugMode(): boolean {
    return this.config.debugMode;
  }

  /**
   * Log debug information (only in debug mode)
   */
  log(message: string, ...args: unknown[]): void {
    if (this.config.debugMode) {
      console.log(`[AB Test Debug] ${message}`, ...args);
    }
  }

  /**
   * Log warning information (only in debug mode)
   */
  warn(message: string, ...args: unknown[]): void {
    if (this.config.debugMode) {
      console.warn(`[AB Test Warning] ${message}`, ...args);
    }
  }

  /**
   * Log error information (always logged, regardless of debug mode)
   * Critical errors should always be visible
   */
  error(message: string, ...args: unknown[]): void {
    console.error(`[AB Test Error] ${message}`, ...args);
  }
}
